import { AppLogo } from '@/components/common/AppLogo';
import { formatDisplayDate } from '@/utils/date';
import type { PcmpMoReport } from '../../types/pcmpMoReport.types';
import { PcmpMoReportTable } from './PcmpMoReportTable';

/** The MO Wise report as printed: heading, what it covers, then the figures. */
export function PcmpMoReportSheet({ report }: { report: PcmpMoReport }) {
  return (
    <div className="flex flex-col gap-3 text-neutral-900">
      <div className="flex items-center justify-between gap-4">
        <AppLogo className="size-9" />
        <div className="text-right">
          <h1 className="text-base font-bold">MO Wise PCMP Report</h1>
          <p className="text-xs text-neutral-600">
            {report.scopeLabel} · {report.projectLabel} · {report.periodLabel}
          </p>
          <p className="text-xs text-neutral-600">As of {formatDisplayDate(report.reportDate)}</p>
        </div>
      </div>
      {report.message ? (
        <p className="text-sm">{report.message}</p>
      ) : (
        <PcmpMoReportTable report={report} />
      )}
    </div>
  );
}
